import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { AnimalMilkYield } from "@project/types/vrindavan-gaushala";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/animal-milk-yields`;
const SILENT: RequestConfig = { showNotification: false };

class AnimalMilkYieldService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<AnimalMilkYield>> => {
    return fetchListPage<AnimalMilkYield>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<AnimalMilkYield | undefined> => {
    const data = await get<ApiItemResponse<AnimalMilkYield> | AnimalMilkYield>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: Record<string, unknown>
  ): Promise<AnimalMilkYield | undefined> => {
    const data = await post<
      ApiItemResponse<AnimalMilkYield> | AnimalMilkYield,
      Record<string, unknown>
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Record<string, unknown>
  ): Promise<AnimalMilkYield | undefined> => {
    const data = await patch<
      ApiItemResponse<AnimalMilkYield> | AnimalMilkYield,
      Record<string, unknown>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const animalMilkYieldService = new AnimalMilkYieldService();
